export const TransformImages = {
  "0": (
    <img
      draggable={false}
      src={new URL(`../../img/transform_0.png`, import.meta.url).href}
      style={{ height: 40, width: 40 }}
    />
  ),
  "90": (
    <img
      draggable={false}
      src={new URL(`../../img/transform_90.png`, import.meta.url).href}
      style={{ height: 40, width: 40 }}
    />
  ),
  "180": (
    <img
      draggable={false}
      src={new URL(`../../img/transform_180.png`, import.meta.url).href}
      style={{ height: 40, width: 40 }}
    />
  ),
  "270": (
    <img
      draggable={false}
      src={new URL(`../../img/transform_270.png`, import.meta.url).href}
      style={{ height: 40, width: 40 }}
    />
  ),
  "flip-x": (
    <img
      draggable={false}
      src={new URL(`../../img/transform_flipx.png`, import.meta.url).href}
      style={{ height: 40, width: 40 }}
    />
  ),
  "flip-y": (
    <img
      draggable={false}
      src={new URL(`../../img/transform_flipy.png`, import.meta.url).href}
      style={{ height: 40, width: 40 }}
    />
  ),
  d1: (
    <img
      draggable={false}
      src={new URL(`../../img/transform_d1.png`, import.meta.url).href}
      style={{ height: 40, width: 40 }}
    />
  ),
  d2: (
    <img
      draggable={false}
      src={new URL(`../../img/transform_d2.png`, import.meta.url).href}
      style={{ height: 40, width: 40 }}
    />
  ),
};

export const TransformLabels = {
  "0": "0º",
  "90": "90º",
  "180": "180º",
  "270": "-90º",
  "flip-x": "Flipped horizontally",
  "flip-y": "Flipped vertically",
  d1: "Diagonal 1",
  d2: "Diagonal 2",
};
